var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue";
var _hoisted_1 = { class: "w-[260px]" };
var _hoisted_2 = ["src"];
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
var _hoisted_4 = ["src"];
var _hoisted_5 = { class: "flex items-center" };
import ESelect from '@common/ui/ESelect/ESelect.vue';
import EMenuItem from '@common/ui/EMenu/EMenuItem.vue';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import passData from '@common/utils/PassData';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChangeLang',
    props: {
        onChange: { type: Function }
    },
    setup: function (__props) {
        var _this = this;
        var _a, _b;
        var props = __props;
        var locale = useI18n().locale;
        var localeCurrent = ((props === null || props === void 0 ? void 0 : props.onChange) && ((_a = passData === null || passData === void 0 ? void 0 : passData.schoolSettings) === null || _a === void 0 ? void 0 : _a.language))
            ? ref((_b = passData === null || passData === void 0 ? void 0 : passData.schoolSettings) === null || _b === void 0 ? void 0 : _b.language)
            : ref(locale.value);
        var localeOptions = [
            {
                value: 'ru',
                label: 'Русский',
                meta: {
                    img: '/img/common/components/footer/russia.png'
                }
            },
            {
                value: 'en',
                label: 'English',
                meta: {
                    img: '/img/common/components/footer/united-kingdom.png'
                }
            },
            {
                value: 'kk',
                label: 'Қазақша',
                meta: {
                    img: '/img/common/components/footer/kk.png'
                }
            },
            {
                value: 'uz',
                label: "O'zbekcha",
                meta: {
                    img: '/img/common/components/footer/uz.png'
                }
            },
            {
                value: 'es',
                label: 'Español',
                meta: {
                    img: '/img/common/components/footer/es.png'
                }
            },
            {
                value: 'it',
                label: 'Italiano',
                meta: {
                    img: '/img/common/components/footer/it.png'
                }
            },
            {
                value: 'de',
                label: 'Deutsch',
                meta: {
                    img: '/img/common/components/footer/de.png'
                }
            },
            {
                value: 'fr',
                label: 'Français',
                meta: {
                    img: '/img/common/components/footer/fr.png'
                }
            }
        ];
        var currentOptions = computed(function () { return localeOptions.find(function (l) { return l.value === localeCurrent.value; }); });
        var localChange = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.onChange) return [3 /*break*/, 2];
                        return [4 /*yield*/, props.onChange(localeCurrent.value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        locale.value = localeCurrent.value;
                        localStorage.setItem('locale', localeCurrent.value);
                        //обновляю приложение после смены языка
                        window.location.reload();
                        return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ESelect, {
                    modelValue: _unref(localeCurrent),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(localeCurrent) ? (localeCurrent).value = $event : null); }),
                    options: localeOptions,
                    class: "mb-5",
                    size: "large",
                    theme: "white",
                    onChange: localChange
                }, {
                    prepend: _withCtx(function () {
                        var _a, _b;
                        return [
                            _createElementVNode("img", {
                                src: (_b = (_a = currentOptions.value) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.img,
                                class: "w-5 h-5 mr-1"
                            }, null, 8, _hoisted_2)
                        ];
                    }),
                    option: _withCtx(function () { return [
                        _hoisted_3
                    ]; }),
                    additionalAfter: _withCtx(function (_a) {
                        var isSelected = _a.isSelected, onOptionClick = _a.onOptionClick;
                        return [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(localeOptions, function (recently) {
                                return _createVNode(EMenuItem, {
                                    key: recently.value,
                                    "is-selected": isSelected(recently),
                                    onSelect: function ($event) { return (onOptionClick(recently)); }
                                }, {
                                    default: _withCtx(function () { return [
                                        _createElementVNode("img", {
                                            src: recently.meta.img,
                                            class: "w-5 h-5 mr-4"
                                        }, null, 8, _hoisted_4),
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(recently.label), 1)
                                    ]; }),
                                    _: 2
                                }, 1032, ["is-selected", "onSelect"]);
                            }), 64))
                        ];
                    }),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
